var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess72(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69 36c0 18.225-14.775 33-33 33S3 54.225 3 36 17.775 3 36 3s33 14.775 33 33Zm3 0c0 19.882-16.118 36-36 36S0 55.882 0 36 16.118 0 36 0s36 16.118 36 36Zm-22.94-6.94a1.5 1.5 0 0 0-2.12-2.12L32 41.878l-6.94-6.94a1.5 1.5 0 0 0-2.12 2.122l8 8a1.5 1.5 0 0 0 2.12 0l16-16Z",
    fill: "#6BD962"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess72);
export default __webpack_public_path__ + "static/media/success_72.1c8ad6f8.svg";
export { ForwardRef as ReactComponent };